module.exports = __webpack_public_path__ + "img/freight_yard3_3.3247d6f8.png";